import { createContext, useContext } from "react";
import type { CatalogProgressMeta, CollectionItem } from "../api/types";
import type {
  CollectionProgressSummary,
  FilterProgressOption,
} from "./collection-progress";
import type {
  CollectionRarityFilter,
  CollectionViewFilters,
} from "./collection-filters";
import type { CollectionUiSort } from "./collection-sort";

export type CollectionViewContextValue = {
  filters: CollectionViewFilters;
  years: number[];
  yearOptions: FilterProgressOption[];
  seriesNames: string[];
  seriesOptions: FilterProgressOption[];
  seriesEnabled: boolean;
  visibleItems: CollectionItem[];
  progressItems: CollectionItem[];
  progress: CollectionProgressSummary;
  progressMeta: CatalogProgressMeta | null;
  emptyKind: "none" | "collection" | "search" | "series" | "rarity" | "year" | "filters";
  setQuery: (query: string) => void;
  setYear: (year: string) => void;
  setSeries: (series: string) => void;
  setRarity: (rarity: CollectionRarityFilter) => void;
  setSort: (sort: CollectionUiSort) => void;
  resetFilters: () => void;
  ensureProgressMeta: () => Promise<void>;
};

export const CollectionViewContext = createContext<CollectionViewContextValue | null>(
  null,
);

export function useCollectionView(): CollectionViewContextValue {
  const value = useContext(CollectionViewContext);
  if (!value) {
    throw new Error("useCollectionView must be used within CollectionViewProvider");
  }
  return value;
}
